<template>
  <fade-transition>
    <div v-if="isVisible" :class="`my-alert my-alert--${variant}`">
      <div class="my-alert__content">
        <div class="my-alert__icon">
          <mdicon :name="rightIcon" size="24" />
        </div>
        <div class="my-alert__text">{{ text }}</div>
      </div>
      <div v-if="hasClose" @click="handleHide" class="my-alert__close">
        <mdicon name="close" size="16" />
      </div>
    </div>
  </fade-transition>
</template>

<script>
import { ref } from "vue";
export default {
  props: {
    variant: {
      type: String,
      default: "info",
    },
    rightIcon: {
      type: String,
      default: "help-circle-outline",
    },
    text: {
      type: String,
      default: "",
    },
    hasClose: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    const toasts = ref([]);

    // Add a new toast alert to the array
    const addToast = ({ message, type, duration = 3000 }) => {
      const id = new Date().getTime(); // Generate a unique ID for the toast
      toasts.value.push({ id, message, type });

      // Set a timeout to remove the toast after the specified duration
      setTimeout(() => {
        const index = toasts.value.findIndex((toast) => toast.id === id);
        if (index !== -1) {
          toasts.value.splice(index, 1);
        }
      }, duration);
    };

    // Remove a toast alert from the array
    function dismiss(index) {
      toasts.value.splice(index, 1);
    }

    const isVisible = ref(false);
    setTimeout(() => {
      isVisible.value = true;
    }, 500);
    const handleHide = () => (isVisible.value = false);

    // return data to be used in template
    return { toasts, addToast, dismiss, isVisible, handleHide };
  },
};
</script>
